export default "__VITE_ASSET__BRgmcw$F__"